module.exports = __webpack_public_path__ + "img/avatar2.96fcb540.png";